<template>
    <v-dialog
        v-model="openAddFR"
        persistent
        max-width="500px"
        transition="openAddFR-transition"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title> Add FlatRate </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon left @click="$emit('close')"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" lazy-validation v-model="valid">
                    <v-row>
                        <v-col>
                            <v-combobox
                                v-model="rate"
                                :items="rates"
                                :item-text="'Text'"
                                :item-value="'RateId'"
                                label="Rate"
                                dense
                                hide-details
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                    <v-col>
                        <v-combobox v-model="type" :items="types" :item-text="'text'"
                            :item-value="'id'" label="Type"
                            dense hide-details></v-combobox>
                    </v-col>
                </v-row> -->
                    <v-row>
                        <v-col>
                            <v-text-field
                                label="Amount"
                                v-model="amount"
                                dense
                                hide-details
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
                <v-row justify="end">
                    <v-btn
                        color="secondary"
                        @click="validate"
                        small
                        class="mr-5 mt-3 mb-3"
                        >Save</v-btn
                    >
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
function logErr(error) {
    console.log(error);
}
import axios from 'axios';
export default {
    props: ['openAddFR'],
    data: function() {
        return {
            rates: [],
            rate: null,
            valid: true,
            types: [
                { id: 1, text: 'FrontHaul' },
                { id: 2, text: 'BackHaul' }
            ],
            amount: null,
            type: null
        };
    },
    mounted() {
        this.loadRates();
    },
    methods: {
        loadRates: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('group-rate/all/rates')
                .then(response => {
                    this.rates = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.newFlatRate();
            } else {
                this.$refs.form.validate();
            }
        },
        newFlatRate: function() {
            var parms = {
                MainRate: this.rate.RateId,
                Amount: this.amount
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('main-flat-rate', parms)
                .then(async response => {
                    console.log(response.data);
                    this.$emit('close');
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
